import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import MhFooter from "./Footer/MHFooter";
import Header from "./Header/Header";
import styles from "./Layout.module.css";
import Navigation from "./Navbar/Navigation";
import classes from "./Footer/MHFooter.module.css";
import HeaderMenu from "./Header/HeaderMenu";

function Layout() {
  const location = useLocation();

  const [showHeader, setShowHeader] = useState(true);

  const [showNav, setShowNav] = useState(false);

  const [showImg, setShowImage] = useState(false);

  const [imgToDisplay, setImgToDispaly] = useState(
    "/Images/Content/HomePage.jpg"
  );

  const splitPath = (p) => {
    return p.split("/");
  };

  const IsSamePage = (pathname, previous) => {
    if (previous == undefined || previous == null) {
      return false;
    }
    let path = splitPath(pathname)[1];
    let prior = splitPath(previous)[1];

    if (path != prior) {
      return false;
    }

    return true;
  };

  const SelectImage = (p) => {
    if (p.length <= 0) {
      setImgToDispaly("/Images/Content/HomePage/HomePage.jpg");
    }

    switch (p[1].toLowerCase()) {
      case "products":
        // return setImgToDispaly("/Images/Content/mh-logo-name-transparent.png")
        
          setShowImage(false);
        
        break;
      case "occasions":
        
          setShowImage(false);
        
        break;
      default:
        setImgToDispaly("/Images/Content/HomePage/HomePage.jpg");
    }
  };

  useEffect(() => {
    console.table(location);

    if (!IsSamePage(location.pathname, location.state)) {
      window.scrollTo(0, 0);
    }

    let page = splitPath(location.pathname);

    if (page.length > 1) {
      setShowImage(true);
      SelectImage(page);
    } else {
      setShowImage(false);
    }
  }, [location]);

  const copywright = showNav ? classes.ForceFooter : styles.copywright;

  return (
    <div className={styles.grain}>      
      {showHeader ? <Header showNavHandler={setShowNav} /> : null}      
      <main>
        <Navigation checked={showNav} />
        
        {!showNav ? <Outlet /> : null}
      </main>
      <MhFooter ShowNav={showNav} />
      <div className={`${copywright}`}>Matchhampers (Jersey) Ltd. &copy; 2026 </div>
    </div>
  );
}

export default Layout;
